<template>
  <Layout>
    <div>
      <TagTable
          :on-log-action="showLogModal"
          :loading="isLoading"
          :tags="tags"
          :add-new-tag="() => tagModalVisible = true"
          :edit-tag="handleEdit"
          :delete-tag="handleDeleteTag"
          :current-sort="currentSort"
          :on-sort="handleSort"
      />

      <div class="pagination-align-center">
        <Pagination :total-items="totalItems" :per-page="20" :current-page="currentPage" :on-page-change="handlePage"/>
      </div>

      <LogModal
          :visible="isLogModalVisible"
          :on-hide="hideLogModal"
          :data="logData"
          :total-items="logMeta.total"
          :current-page="logMeta.currentPage"
          :per-page="logMeta.perPage"
          :on-page-change="handleLogPageChange"
      />
    </div>

    <TagModal :is-visible="tagModalVisible" :on-close="() => tagModalVisible = false" :refresh-callback="refreshData" />
    <TagModal :is-visible="tagEditModalVisible" :on-close="() => tagEditModalVisible = false" :edit-mode="true" :edit-data="editData" :refresh-callback="refreshData" />
    <ConfirmDeleteModal :is-visible="confirmDeleteModalVisible" :on-close="onTagDeleteCancel" message="Tag will be deleted permanently" :on-action="handleDeleteRequest" />

  </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import TagTable from "@/components/tables/TagTable.vue";
import tagService from "@/service/tagService";
import TagModal from "@/components/modals/TagModal.vue";
import ConfirmDeleteModal from "@/components/modals/ConfirmDeleteModal.vue";
import {handleErrorResponse} from "../utils/utils";
import LogModal from "@/components/modals/LogModal.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    LogModal,
    ConfirmDeleteModal,
    TagModal,
    TagTable,
    Layout,
    Pagination
  },
  data() {
    return {
      logData: [],
      logMeta: {
        total: 0,
        currentPage: 1,
        perPage: 20
      },
      isLogModalVisible: false,
      isLoading: true,
      tags: [],
      totalItems: 0,
      currentPage: 1,
      tagModalVisible: false,
      tagEditModalVisible: false,
      confirmDeleteModalVisible: false,
      editData: {},
      deleteId: null,
      currentSort: {
        column: null,
        direction: null
      }
    }
  },
  watch: {
    $route() {
      this.getTags(1);
    }
  },
  mounted() {
    this.getTags(1);

    const routeQuery = this.$route.query;
    if (routeQuery.sortBy && routeQuery.sortDirection) {
      this.currentSort = {
        column: routeQuery.sortBy,
        direction: routeQuery.sortDirection
      };
    }
  },
  methods: {
    handleSort(column, direction) {
      this.currentSort = {
        column: column,
        direction: direction
      };

      const query = { ...this.$route.query };

      if (column && direction) {
        query.sortBy = column;
        query.sortDirection = direction;
      } else {
        delete query.sortBy;
        delete query.sortDirection;
      }

      this.$router.push({ query });
      this.currentPage = 1;
      this.getTags(1);
    },

    getLogs(page = 1) {
      tagService.getLogs(this.$i18n.locale, page, 20).then((res) => {
        const response = res.data.data;
        this.logData = response.data;
        this.logMeta = {
          total: response.total,
          currentPage: response.current_page,
          perPage: response.per_page
        };
      }).catch((err) => {
        handleErrorResponse(err, this.$snackbar);
      });
    },

    handleLogPageChange(page) {
      if (this.logMeta.currentPage === page) return;
      this.logMeta.currentPage = page;
      this.getLogs(page);
    },

    showLogModal() {
      this.isLogModalVisible = true;
      this.logMeta.currentPage = 1;
      this.getLogs(1);
    },

    hideLogModal() {
      this.isLogModalVisible = false;
    },

    getTags(page) {
      this.isLoading = true;

      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.sortBy && routeQuery.sortDirection) {
        const orderByArray = [{
          column: routeQuery.sortBy,
          direction: routeQuery.sortDirection
        }];

        tempFilters.push({
          key: 'orderBy',
          value: orderByArray
        });

        this.currentSort = {
          column: routeQuery.sortBy,
          direction: routeQuery.sortDirection
        };
      }

      tagService.getTags(page, tempFilters).then(response => {
        const data = response.data.data;
        this.tags = data.data;
        this.totalItems = data.total;
        this.currentPage = data.current_page;
        this.isLoading = false;
      }).catch(error => {
        handleErrorResponse(error, this.$snackbar);
        this.isLoading = false;
      });
    },

    handlePage(page) {
      if (this.isLoading && this.currentPage !== 1) return;
      this.currentPage = page;
      this.getTags(page);
    },

    refreshData() {
      this.getTags(this.currentPage);
    },

    handleEdit(data) {
      this.editData = data;
      this.tagEditModalVisible = true;
    },

    handleDeleteTag(tagId) {
      event.stopPropagation();
      this.deleteId = tagId;
      this.confirmDeleteModalVisible = true;
    },

    onTagDeleteCancel() {
      this.confirmDeleteModalVisible = false;
      this.deleteId = null;
    },

    handleDeleteRequest() {
      if (!this.deleteId) {
        return;
      }

      this.confirmDeleteModalVisible = false;
      this.isLoading = true;

      tagService.deleteTag(this.deleteId).then(response => {
        this.deleteId = null;
        this.refreshData();

        this.$snackbar.add({
          text: this.$t('tag_deleted'),
          type: 'error',
        })
      }).catch(error => {
        handleErrorResponse(error, this.$snackbar)
      }).finally(() => {
        this.isLoading = false;
      })
    }
  },
}
</script>

<style scoped>

</style>
